import { Image, Text, View } from '@react-pdf/renderer';

import styles from './GlobalPlotsStyles.ts';

interface GlobalPlotImage {
  photometry: string;
  url: string;
  graphType: string;
}

interface GlobalPlotsProps {
  title: string;
  images: GlobalPlotImage[];
}

const GlobalPlots = ({ title, images }: GlobalPlotsProps) => {
  const orderedImages = [...images].sort((a, b) => {
    const order = { false_color: 0, isocontour: 1 } as const;
    return order[a.graphType as keyof typeof order] - order[b.graphType as keyof typeof order];
  });

  return (
    <View style={styles.container}>
      <Text style={styles.titleContent}>{title}</Text>

      <View style={styles.imageContent}>
        {orderedImages.map((image, index) => (
          <View key={`${image.graphType}-${image.photometry}-${index}`} style={{ marginBottom: 20 }} break={index > 0}>
            <Text style={styles.imageTitle}>
              {image.graphType.replace(/_/g, ' ')} - {image.photometry.replace(/_/g, ' ')}
            </Text>
            <Image style={styles.descriptionImage} src={image.url} />
          </View>
        ))}
      </View>
    </View>
  );
};

export default GlobalPlots;
